"use client";
import { Content } from "@/services/content/types";
import Link from "next/link";
import { usePathname } from "next/navigation";

type MenuProps = {
  items: Content.Page[];
  title?: string;
};

const MenuBlock = (props: MenuProps) => {
  const currentPath = usePathname();

  return (
    <div className="container lg:px-24  mb-8 my-8 flex gap-4">
      {props.title && (
        <div className="text-center uppercase section-title">{props.title}</div>
      )}
      <ul className="flex-wrap flex gap-2">
        {props.items.map((_item) => (
          <div key={_item.sys.id}>
            <li>
              {_item.fields.slug && (
                <Link
                  className={`btn btn-default text-nowrap ${
                    currentPath === `/${_item.fields.slug}` ? "bg-sand-700" : ""
                  }`}
                  href={`/${_item.fields.slug}`}
                >
                  {_item.fields.menuTitle || _item.fields.title}
                </Link>
              )}
            </li>
          </div>
        ))}
      </ul>
    </div>
  );
};

export default MenuBlock;
